module.exports = __webpack_public_path__ + "img/16-2.013aed71.jpg";